export const SET_SCHEDULE = 'SCHEDULE/SET_SCHEDULE'
export const SET_SCHEDULES = 'SCHEDULE/SET_SCHEDULES'
